// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"logoBuddies_logoWrapper__CELLg","logoText":"logoBuddies_logoText__kDz3z","logoWhite":"logoBuddies_logoWhite__4d3xh","buddies":"logoBuddies_buddies__j3rF5"};